import * as React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS, Paper as PaperOrigin, Scrollbar as ScrollbarOrigin } from 'components/UI'
import ReduxEntitySelect from 'components/FormElements/ReduxForm/ReduxEntitySelect'
// graphql
import { PLAN_TYPES_SELECT_QUERY } from 'graphql/planType/queries'
// themes
import { colors } from 'themes/index'
// utils
import get from 'lodash/get'
import { required } from 'utils/index'
import { generateFields } from 'utils/fields'
// types
import { IField } from 'types/graphql'
import { IOption } from 'components/FormElements/Select'
// utils
import { planTypeProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

// styled
const Form = styled('form')`
  display: flex;
  flex-direction: column;
  height: calc(100% - 64px);
`

const BottomPaper = styled(PaperOrigin)`
  && {
    align-items: center;
    background: ${colors.gray200};
    display: flex;
    height: 56px;
    padding: 10px 20px;

    & > div {
      padding: 8px;
    }
  }
`

const Scrollbar = styled((props) => <ScrollbarOrigin {...props} />)`
  height: 100%;
  padding: 0 16px;

  > div {
    padding: 12px;
  }
`

// types
interface IIncomingProps {
  fields: IField[]
  form: string
  hideModal: () => void
  isSubPlanCreation: boolean
  planType: IOption
}

type IProps = InjectedFormProps & IIncomingProps

const CreatePlanForm: React.FC<IProps> = ({ fields, form, handleSubmit, hideModal, isSubPlanCreation, planType }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Scrollbar>
        {get(planType, 'value') ? (
          fields.map((field) => generateFields({ field, form, canModify: true, canSetPermissions: true }))
        ) : (
          <ReduxEntitySelect
            label={'Plan Type'}
            name={'planType'}
            query={PLAN_TYPES_SELECT_QUERY}
            validate={[required]}
            {...planTypeProps}
          />
        )}
      </Scrollbar>

      {!isSubPlanCreation && (
        <BottomPaper square>
          <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE}>
            Create
          </Button>
          <Button type={'button'} layout={BUTTON_LAYOUTS.WHITE} onClick={hideModal}>
            Cancel
          </Button>
        </BottomPaper>
      )}
    </Form>
  )
}

export default reduxForm({ enableReinitialize: true })(CreatePlanForm)
